  console.log('collection code started');
// find if any collection lists are set to use carousel on mobile or have already been initialized
let collection_list_slick = document.querySelectorAll('.collection-list.slick');

// calls slick function on load if mobile carousel has been chosen
if (collection_list_slick.length !== 0 && $(window).width() < 750) {
    console.log('mobile resolution');
  collectionListSlick();
}
if (collection_list_slick.length !== 0) {
  const collection_list_mq = window.matchMedia('(max-width: 749px)');
  collection_list_mq.addEventListener('change', (e) => collectionListSlick());
}

function collectionListSlick() {
  console.log('function triggered');
  let collection_list_initialized = document.querySelectorAll('.collection-list.slick-initialized');
  if (collection_list_slick.length !== 0 && $(window).width() < 750) {
    // Loops through collection lists and adds an incremental class to identify them then initialises a slick slider (prevents them from controlling each other)
    var clsNum = 0;
    $('.collection-list.slick').each(function(i, obj) {
      var slides_mobile = $(this).attr('data-slides-mobile');
      clsNum++;
      $(this).addClass('cls' + clsNum);
      $(this).slick({
        lazyLoad: 'ondemand',
        speed: 300,
        easing: 'ease',
        slidesToShow: parseInt(slides_mobile, 10),
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev visually-hidden-device" aria-label="Previous Slide"><svg width="100%" height="100%" viewBox="0 0 20 20"><g transform="matrix(-0.00561986,-0.00561986,0.00561986,-0.00561986,7.09528,27.8618)"><path d="M510.38,1027.25L2151.09,1027.25L2151.09,2667.96" fill="none" stroke="currentColor" stroke-width="80"/></g></button>',
        nextArrow: '<button type="button" class="slick-next visually-hidden-device" aria-label="Next Slide"><svg width="100%" height="100%" viewBox="0 0 20 20"><g transform="matrix(0.00561986,0.00561986,-0.00561986,0.00561986,12.9047,-7.86183)"><path d="M510.38,1027.25L2151.09,1027.25L2151.09,2667.96"  fill="none" stroke="currentColor" stroke-width="80"/></g></svg></button>',
        asNavFor: '.collection-list_slider-dots.cls' + clsNum,
        instructionsText: 'This carousel contains collection images and links. Use the Previous and Next buttons to move between collections.',
        regionLabel: 'Collection List Carousel'
      });
    });
    // Does the same with the dot navigation
    var cldNum = 0;
    $('.collection-list_slider-dots').each(function(i, obj) {
      cldNum++;
      $(this).addClass('cls' + cldNum);
      $(this).slick({
        speed: 300,
        easing: 'ease',
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        asNavFor: '.collection-list.cls' + cldNum,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: '10%'
      });
    });
  } else if (collection_list_initialized.length !== 0) {
    $('.collection-list.slick-initialized').each(function(i, obj) {
      $(this).slick('unslick');
    });
  }
  // Queues active cards of first Collection List to load in order, and sets all other cards as loaded (otherwise additional collections need to wait for every card of earlier collections to load)
  var colNum = 0;
  $('.collection-list').each(function(i, obj) {
    colNum++;
    $(this).addClass('iteration' + colNum);
  });
  $('.collection-list.iteration1 .slick-active .card-wrapper').each(function(i, obj) {
    $(this).delay(i*200).queue(function() {
      $(this).addClass('loaded').dequeue();
    });
  });
  $('.collection-list.iteration1 .slick-slide:not(.slick-active) .card-wrapper, .collection-list:not(.iteration1) .card-wrapper').each(function(i, obj) {
    $(this).addClass('loaded');
  });
}